import { createReducer, on, Action } from '@ngrx/store';
import { GenesysCloudCobrowseState, initialState } from '../genesys-cobrowse.state';
import { toggleCobrowseVisibility } from '../actions/genesys-cobrowse.actions';

const reducer = createReducer(
  initialState(),
  on(
    toggleCobrowseVisibility,
    (state, { conversationId, visibility }): GenesysCloudCobrowseState => ({
      ...state,
      [conversationId]: visibility
    })
  )
);

export function genesysCloudCobrowseReducer(
  state: GenesysCloudCobrowseState,
  action: Action
): GenesysCloudCobrowseState {
  return reducer(state, action);
}
